import PropTypes from "prop-types";

export const DocumentAttributes = {
  id: PropTypes.number,
  name: PropTypes.string,
  path: PropTypes.string,
  description: PropTypes.string,
  metadata: PropTypes.string,
  url: PropTypes.string,
  sizes: PropTypes.shape({
    medium: PropTypes.string,
  }),
};

export const DocumentType = PropTypes.shape(DocumentAttributes);
